import React from 'react';
import {Link} from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import * as firebase from 'firebase';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import '../common/sortable-list.css';

/** @class ProductList
  * A React Component for listing products
  */
export default class ProductList extends ReactFireComponent {
  /** @constructor
    * Constructs a new product list
    * @prop {string} expoID - the id of the expo these products belong to
    */
  constructor(props) {
    super(props);
    this.dataURL = `expos/${this.props.expoID}/products`;
    this.state = {products: []}
    this.handleNewProduct = this.handleNewProduct.bind(this);
  }
  /** @method componentWillMount
    * Binds the products variable to the database.
    */
  componentWillMount() {
    this.bindAsArray(this.dataURL, 'products');
  }
  /** @method componentWillUnmount
    * Unbinds the product variable.
    */
  componentWillUnmount() {
    this.unbind();
  }
  /** @method handleNewProduct
    * Creates a new product in the firebase database.
    */
  handleNewProduct(){
    const newProduct = {
      name: "New Product",
      manufacturer: ""
    };
    firebase.database().ref(this.dataURL).push(newProduct);
  }
  /** @method removeProduct
    * Removes the specified product from the firebase database.
    * @param {string} productID - the id of the product to remove
    */
  removeProduct(productID) {
    if(window.confirm("Are you sure?  This will permanently delete the product")) {
      firebase.database().ref(this.dataURL).child(productID).remove();
    }
  }
  /** @method render
    * Renders the list of products
    */
  render() {
    var products = this.state.products.map((product, index) => (
      <div key={product.id} className="sortable-list-item">
        {product.name}
        <span>
          <Link to={`/expos/${this.props.expoID}/products/${product.id}`}>
            <FontAwesome name="edit" style={{color: "green"}} />
          </Link>
          <FontAwesome name="times" style={{color: "red"}}
            onClick={() => this.removeProduct(product.id)}
          />
        </span>
      </div>
    ));
    return (
      <div>
        <h1>Products</h1>
        <div className="sortable-list">
          {products}
        </div>
        <button onClick={this.handleNewProduct}>
          <FontAwesome name="plus" />
          Add New Product
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/product-list/product-list.js